"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ResourcePlanning = function ResourcePlanning(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.48,13.8H7.67l1.1,1.09a.28.28,0,0,1,0,.4.29.29,0,0,1-.39,0L6.81,13.72a.28.28,0,0,1,0-.4l1.57-1.56a.28.28,0,0,1,.39.39l-1.1,1.09h3.81a.28.28,0,0,1,0,.56Zm4.62,1.49a.29.29,0,0,1-.39,0,.28.28,0,0,1,0-.4L16.8,13.8H13a.28.28,0,0,1,0-.56h3.8l-1.09-1.09a.28.28,0,0,1,.39-.39l1.57,1.56a.28.28,0,0,1,0,.4Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.3,9h-.69l-.1-.09a2.09,2.09,0,0,0-.87-4h-1V4.76a.2.2,0,0,0-.19-.19h-1.1a.2.2,0,0,0-.19.19v.16H9.54V4.76a.2.2,0,0,0-.19-.19H8.25a.19.19,0,0,0-.19.19v.16h-.7a2.09,2.09,0,0,0-.87,4L6.39,9H5.73a.2.2,0,0,0-.2.2h0a.2.2,0,0,0,.19.19h.44a.86.86,0,0,0,0,.28,1,1,0,0,0,2,0,1,1,0,0,0-.18-.58h.4a1,1,0,0,0,.8,1.57,1,1,0,0,0,1-.81h3.8a1,1,0,0,0,1,.81,1,1,0,0,0,.8-1.57h.4a1,1,0,0,0-.18.58,1,1,0,1,0,2,0,.86.86,0,0,0,0-.28h.46a.2.2,0,0,0,.2-.19h0A.2.2,0,0,0,18.3,9Zm-1.54.1.15,0a.6.6,0,1,1-.62.6A.58.58,0,0,1,16.76,9.1ZM5.65,7a1.71,1.71,0,0,1,1.71-1.7h9.28A1.7,1.7,0,0,1,17,8.69h-.06a1,1,0,0,0-.25,0H15.13a1.07,1.07,0,0,0-.25,0,1,1,0,0,0-.25,0H9.37a1,1,0,0,0-.25,0,1,1,0,0,0-.24,0H7.36a1,1,0,0,0-.25,0H7.05A1.71,1.71,0,0,1,5.65,7ZM9.27,9.1a.6.6,0,1,1-.75.58A.61.61,0,0,1,9,9.1ZM15,9.1a.61.61,0,0,1,.46.58.6.6,0,1,1-.75-.58Zm-7.78,0a.58.58,0,0,1,.47.58.6.6,0,1,1-.62-.6Z",
    fill: "#fff"
  }));
};

var _default = ResourcePlanning;
exports["default"] = _default;